import MainApp from "@/views/MainApp";
import Home from "@/views/Home";
import FAQ from "@/views/FAQ";
import Legis from "@/views/Legis";
import Mairie from "@/views/Mairie";
import ResetPassword from "@/views/ResetPassword";
import SignupLogin from "@/views/SignupLogin";
import i18n from "../plugins/i18n";
import features from "@/configs/features";
import { useUserStore } from "../stores/user";

// The main app, with top navbar
export default {
  path: "/",
  name: "Main App",
  component: MainApp,
  meta: {
    title: i18n.global.t("meta.title.main_app"),
    metaTags: [
      {
        name: "description",
        content: i18n.global.t("meta.tags.main_app"),
      },
      {
        property: "og:description",
        content: i18n.global.t("meta.tags.main_app"),
      },
    ],
  },
  children: [
    {
      path: "/",
      name: "home",
      component: Home,
    },
    ...(features.LEGIS
      ? [
          {
            path: i18n.global.t("path.legis"),
            name: "legislatif",
            component: Legis,
            meta: {
              title: i18n.global.t("meta.title.legis"),
              metaTags: [
                {
                  name: "description",
                  content: i18n.global.t("meta.tags.legis"),
                },
              ],
            },
          },
        ]
      : []),
    {
      path: i18n.global.t("path.faq"),
      name: "faq",
      component: FAQ,
      meta: {
        title: i18n.global.t("meta.title.faq"),
        metaTags: [
          {
            name: "description",
            content: i18n.global.t("meta.tags.faq"),
          },
        ],
      },
    },
    {
      path: i18n.global.t("path.signup_login"),
      name: "signup-login",
      component: SignupLogin,
      meta: {
        title: i18n.global.t("meta.title.signup_login"),
      },
      beforeEnter: (from, to, next) => {
        const userStore = useUserStore();
        if (userStore.loggedIn) {
          next("/");
          return;
        }
        next();
      },
    },
    {
      // This path is better of not being translated.
      // We want to keep this path fix for backend email to have the correct url
      path: "/reset",
      name: "reset",
      component: ResetPassword,
      meta: {
        title: i18n.global.t("meta.title.reset_password"),
      },
      beforeEnter: (from, to, next) => {
        const userStore = useUserStore();
        if (!from.query.email || !from.query.token) {
          next("/");
          return;
        }
        if (userStore.loggedIn) {
          next("/");
          return;
        }
        next();
      },
    },
    {
      path: i18n.global.t("path.mairie"),
      name: "mairie",
      component: Mairie,
      beforeEnter: (from, to, next) => {
        const userStore = useUserStore();
        if (!userStore.isUser) {
          next(i18n.global.t("path.signup_login"));
          return;
        }
        next();
      },
    },
  ],
};
